// Design tokens. Source of truth for color, type, spacing, radius.
// Mirrors the palette in docs/agents/how-to-validate-agents/UI-Layer/styles.css
// + the prior mockup at docs/backlog/a2a/Agent-Studio/agent-studio-mockup.html.

export const colors = {
  ink: { 50: '#EFF6FF', 100: '#DBEAFE', 200: '#BFDBFE', 500: '#3B82F6', 600: '#2563EB', 700: '#1D4ED8' },
  violet: { 50: '#F5F3FF', 100: '#EDE9FE', 200: '#DDD6FE', 500: '#8B5CF6', 600: '#7C3AED', 700: '#6D28D9' },
  green: { 100: '#D1FAE5', 500: '#10B981', 600: '#059669', 700: '#047857' },
  amber: { 100: '#FEF3C7', 500: '#F59E0B', 600: '#D97706', 700: '#B45309' },
  red: { 100: '#FEE2E2', 500: '#EF4444', 600: '#DC2626', 700: '#B91C1C' },
  slate: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
};

export const typography = {
  fontUi: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontMono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
};

export const radius = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  full: 999,
};

export const spacing = {
  px1: 4,
  px2: 8,
  px3: 12,
  px4: 16,
  px5: 20,
  px6: 24,
  px8: 32,
  px10: 40,
  px12: 48,
};
